export default __webpack_public_path__ + "static/media/welcome-back-bmm.46fcd3ed.svg";